import { ICONS_DETAILS_ACTION, ICONS_DETAILS_KEY } from 'src/redux/constants';
import type { ViewAction, ViewActionPayload } from 'src/redux/viewState/types';

export const getIconsDetails = (params?: ViewActionPayload): ViewAction => {
  return {
    type: ICONS_DETAILS_ACTION,
    dataKey: ICONS_DETAILS_KEY,
    value: params,
  };
};
